import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultAtMentionComponent = ({
  node,
  view,
  getPos,
  onAtMentionClick
}) => {
  const isClickable = typeof onAtMentionClick === 'function';
  const role = isClickable ? 'button' : undefined;
  const handleClick = () => {
    if (isClickable) {
      onAtMentionClick(node.attrs.id, {
        node,
        view,
        getPos
      });
    }
  };
  return /*#__PURE__*/_jsx("span", {
    role: role,
    onClick: handleClick,
    children: node.attrs.display || `@${node.attrs.name}`
  });
};